<template>
  <Toast />
  <div class="surface-section px-2 py-2 md:px-4">
    <div class="grid">
      <div class="col-12 md:col-2">
        <div class="card p-2">
          <span class="especialidades-title">MENÚS</span>
          <ul class="list-none p-0 m-0 mt-2 text-center">
            <li v-for="recurso in recursos" :key="recurso.id" class="mb-1">
              <span
                @click="filtrarPorRecurso(recurso.id, recurso.color, recurso.text_color)"
                class="consultorio-name"
                :style="
                  recurso.id === recursoSeleccionadaId
                    ? { background: recurso.color, color: recurso.text_color, border: '2px solid ' + recurso.color }
                    : {
                        background: '#fafafa',
                        color: '#374151',
                        borderLeft: '4px solid ' + recurso.color,
                        borderTop: '1px solid #e5e7eb',
                        borderRight: '1px solid #e5e7eb',
                        borderBottom: '1px solid #e5e7eb'
                      }
                "
              >
                {{ recurso.nombre }}
              </span>
            </li>
          </ul>

          <div class="mt-3">
            <span class="especialidades-title">ESTADOS</span>
            <div class="flex flex-column gap-1 mt-2">
              <div class="flex align-items-center gap-2">
                <span class="estado-dot" style="background: #3b82f6"></span>
                <span style="font-size: 11px">Pendiente</span>
              </div>
              <div class="flex align-items-center gap-2">
                <span class="estado-dot" style="background: #22c55e"></span>
                <span style="font-size: 11px">Completada</span>
              </div>
              <div class="flex align-items-center gap-2">
                <span class="estado-dot" style="background: #ef4444"></span>
                <span style="font-size: 11px">Cancelada</span>
              </div>
            </div>
          </div>

          <div class="mt-3">
            <span class="especialidades-title">HOY</span>
            <div class="flex justify-content-between mt-2">
              <div class="text-center">
                <div class="font-bold text-lg" style="color: #3b82f6">{{ totalPendientes }}</div>
                <div style="font-size: 9px; color: #94a3b8; text-transform: uppercase">Pend.</div>
              </div>
              <div class="text-center">
                <div class="font-bold text-lg" style="color: #22c55e">{{ totalCompletadas }}</div>
                <div style="font-size: 9px; color: #94a3b8; text-transform: uppercase">Comp.</div>
              </div>
              <div class="text-center">
                <div class="font-bold text-lg" style="color: #f59e0b">{{ totalIngresos }}</div>
                <div style="font-size: 9px; color: #94a3b8; text-transform: uppercase">Bs</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-12 md:col-10">
        <div class="card p-2">
          <FullCalendar :options="calendarOptions" style="font-size: 12px" />
        </div>
      </div>
    </div>

    <NuevaReserva
      v-if="modalReserva"
      :show="modalReserva"
      :reserva="reservaActual"
      :recursos="recursos"
      :sucursal-id="sucursalId"
      :caja-id="cajaId"
      @closeModal="modalReserva = false"
      @actualizarListado="recargar"
    />
  </div>
</template>

<script>
import FullCalendar from '@fullcalendar/vue3'
import dayGridPlugin from '@fullcalendar/daygrid'
import timeGridPlugin from '@fullcalendar/timegrid'
import interactionPlugin from '@fullcalendar/interaction'
import esLocale from '@fullcalendar/core/locales/es'
import NuevaReserva from '@/module/agendas/NuevaReserva.vue'
import AgendaService from '@/service/AgendaService'
import { useAuth } from '@/stores'

export default {
  components: { FullCalendar, NuevaReserva },

  data() {
    return {
      modalReserva: false,
      reservaActual: {},
      agendas: [],
      agendasFiltradas: [],
      recursos: [],
      recursoSeleccionadaId: null,
      colorRecurso: '#007dd7',
      textColorRecurso: '#ffffff',
      ultimoRango: null,
      sucursalId: null,
      cajaId: null
    }
  },

  created() {
    this.agendaService = new AgendaService()
    this.auth = useAuth()
  },

  mounted() {
    const caja = this.auth?.user?.caja
    if (caja) {
      this.sucursalId = caja.sucursal_id
      this.cajaId = caja.id
    }
  },

  computed: {
    totalPendientes() {
      return this.agendasFiltradas.filter((a) => a.estado === 1).length
    },
    totalCompletadas() {
      return this.agendasFiltradas.filter((a) => a.estado === 2).length
    },
    totalIngresos() {
      return this.agendasFiltradas
        .filter((a) => a.estado !== 0)
        .reduce((s, a) => s + parseFloat(a.precio || 0), 0)
        .toFixed(0)
    },

    calendarOptions() {
      return {
        plugins: [dayGridPlugin, timeGridPlugin, interactionPlugin],
        initialView: 'timeGridDay',
        locales: [esLocale],
        locale: 'es',
        nowIndicator: true,
        headerToolbar: {
          left: 'prev,next today',
          center: 'title',
          right: 'dayGridMonth,timeGridWeek,timeGridDay'
        },
        buttonText: { today: 'Hoy', week: 'Semana', day: 'Día' },
        slotMinTime: '07:00:00',
        slotMaxTime: '23:00:00',
        allDaySlot: false,
        selectable: true,
        selectMirror: true,
        height: 'auto',
        slotDuration: '00:30:00',
        slotLabelInterval: '01:00',
        slotLabelFormat: { hour: 'numeric', minute: '2-digit', meridiem: 'short' },
        selectAllow: (selectInfo) => new Date(selectInfo.startStr) >= new Date(),
        datesSet: this.onDatesSet,
        dateClick: this.onDateClick,
        eventClick: this.onEventClick,
        events: this.eventosCalendario,
        eventDidMount: (info) => {
          const view = info.view.type
          info.el.style.fontSize = view === 'timeGridDay' ? '12px' : view === 'timeGridWeek' ? '10px' : '9px'
          info.el.style.fontWeight = '600'
          info.el.style.cursor = 'pointer'
          info.el.style.borderRadius = '0px'
          info.el.style.borderLeft = '3px solid rgba(0,0,0,0.25)'
          info.el.style.boxShadow = 'none'
        }
      }
    },

    eventosCalendario() {
      return this.agendasFiltradas.map((a) => {
        const recurso = this.recursos.find((r) => r.id === a.recurso_id)
        let bg = recurso?.color || a.color || '#007dd7'
        let text = recurso?.text_color || a.text_color || '#ffffff'
        if (a.estado === 0) {
          bg = '#ef4444'
          text = '#ffffff'
        }
        if (a.estado === 2) {
          bg = '#22c55e'
          text = '#ffffff'
        }

        const anticipo = parseFloat(a.anticipo || 0)
        const titulo =
          anticipo > 0
            ? `${a.nombre_cliente} · ${a.nombre_recurso} · Anticipo: ${anticipo} Bs`
            : `${a.nombre_cliente} · ${a.nombre_recurso} · ${a.nombre_producto || a.observacion || ''}`

        return {
          id: a.id,
          title: titulo,
          start: a.fecha_inicio,
          end: a.fecha_fin,
          backgroundColor: bg,
          borderColor: bg,
          textColor: text,
          extendedProps: {
            cliente_id: a.cliente_id ? parseInt(a.cliente_id) : null,
            telefono: a.telefono,
            recurso_id: a.recurso_id ? parseInt(a.recurso_id) : null,
            nombre_recurso: a.nombre_recurso,
            producto_id: a.producto_id ? parseInt(a.producto_id) : null,
            nombre_producto: a.nombre_producto,
            precio: a.precio,
            anticipo: a.anticipo,
            venta_id: a.venta_id ? parseInt(a.venta_id) : null,
            metodo_pago_id: a.metodo_pago_id ? parseInt(a.metodo_pago_id) : 1,
            observacion: a.observacion,
            estado: a.estado
          }
        }
      })
    }
  },

  methods: {
    onDatesSet(info) {
      const rango = info.startStr + '_' + info.endStr
      if (this.ultimoRango === rango) return
      this.ultimoRango = rango
      this.cargarAgendas(info.startStr, info.endStr)
    },

    cargarAgendas(fecha_inicio = null, fecha_fin = null) {
      this.agendaService.obtenerListado({ fecha_inicio, fecha_fin }).then((res) => {
        this.agendas = res.agendas || []
        this.recursos = res.recursos || []

        this.recursos.unshift({ id: 0, nombre: 'TODAS', color: '#6c757d', text_color: '#ffffff' })

        if (!this.recursoSeleccionadaId) {
          const primera = this.recursos.length === 2 ? this.recursos[1] : this.recursos[0]
          this.recursoSeleccionadaId = primera.id
          this.colorRecurso = primera.color
          this.textColorRecurso = primera.text_color
        }

        this.filtrarPorRecurso(this.recursoSeleccionadaId, this.colorRecurso, this.textColorRecurso)
      })
    },

    filtrarPorRecurso(id, color, textColor) {
      this.recursoSeleccionadaId = id
      this.colorRecurso = color || '#007dd7'
      this.textColorRecurso = textColor || '#ffffff'
      this.agendasFiltradas = id === 0 ? this.agendas : this.agendas.filter((a) => a.recurso_id === id)
    },

    onDateClick(info) {
      if (!info.dateStr || info.dateStr.split('T').length < 2) return
      if (new Date(info.dateStr) < new Date()) {
        this.$toast.add({
          severity: 'warn',
          summary: 'No disponible',
          detail: 'No se puede reservar en horarios pasados',
          life: 2500
        })
        return
      }
      this.reservaActual = {
        fecha: info.dateStr.split('T')[0].split('-').reverse().join('/'),
        hora: info.dateStr.split('T')[1].substring(0, 5),
        duracion: 60,
        recurso_id: this.recursoSeleccionadaId === 0 ? null : this.recursoSeleccionadaId,
        color: this.colorRecurso,
        text_color: this.textColorRecurso,
        precio: 0,
        anticipo: 0,
        metodo_pago_id: 1 // EFECTIVO por defecto
      }
      this.modalReserva = true
    },

    onEventClick(info) {
      const e = info.event
      const ep = e.extendedProps || {}
      this.reservaActual = {
        id: parseInt(e.id),
        fecha: e.startStr.split('T')[0].split('-').reverse().join('/'),
        hora: e.startStr.split('T')[1].substring(0, 5),
        duracion: (new Date(e.end) - new Date(e.start)) / 60000,
        nombre_cliente: e.title.split(' · ')[0],
        cliente_id: ep.cliente_id ? parseInt(ep.cliente_id) : null,
        telefono: ep.telefono || '',
        recurso_id: ep.recurso_id ? parseInt(ep.recurso_id) : null,
        nombre_recurso: ep.nombre_recurso || '',
        producto_id: ep.producto_id ? parseInt(ep.producto_id) : null,
        nombre_producto: ep.nombre_producto || '',
        precio: ep.precio || 0,
        anticipo: ep.anticipo || 0,
        venta_id: ep.venta_id ? parseInt(ep.venta_id) : null,
        metodo_pago_id: ep.metodo_pago_id ? parseInt(ep.metodo_pago_id) : 1,
        observacion: ep.observacion || '',
        estado: ep.estado,
        color: this.colorRecurso,
        text_color: this.textColorRecurso
      }
      this.modalReserva = true
    },

    recargar() {
      this.ultimoRango = null
      this.cargarAgendas()
    }
  }
}
</script>

<style scoped lang="scss">
.especialidades-title {
  font-size: 11px;
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: 0.8px;
  display: block;
  margin-bottom: 6px;
  color: #64748b;
}

.consultorio-name {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 7px 10px;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  cursor: pointer;
  transition: all 0.15s;
  user-select: none;

  &:hover {
    filter: brightness(0.95);
  }
}

.estado-dot {
  width: 9px;
  height: 9px;
  border-radius: 50%;
  display: inline-block;
  flex-shrink: 0;
}

:deep(.fc-event),
:deep(.fc-event-main),
:deep(.fc-timegrid-event),
:deep(.fc-daygrid-event) {
  border-radius: 0 !important;
}

:deep(.fc-timegrid-event .fc-event-main) {
  padding: 2px 4px !important;
}

:deep(.fc-event-title) {
  font-weight: 600 !important;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

:deep(.fc-event-time) {
  font-weight: 700 !important;
  font-size: 10px !important;
}

:deep(.fc-timegrid-col.fc-day-past) {
  opacity: 0.6;
}

@media (max-width: 768px) {
  :deep(.fc-toolbar) {
    flex-wrap: wrap;
    gap: 6px;
  }
  :deep(.fc-toolbar-title) {
    font-size: 0.9rem;
  }
  :deep(.fc-button) {
    font-size: 10px !important;
    padding: 3px 7px !important;
  }
}
</style>